import { render, staticRenderFns } from "./RigaDistintaListaVariazioni.vue?vue&type=template&id=4a125c32&scoped=true"
import script from "./RigaDistintaListaVariazioni.vue?vue&type=script&lang=ts"
export * from "./RigaDistintaListaVariazioni.vue?vue&type=script&lang=ts"
import style0 from "./RigaDistintaListaVariazioni.vue?vue&type=style&index=0&id=4a125c32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a125c32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a125c32')) {
      api.createRecord('4a125c32', component.options)
    } else {
      api.reload('4a125c32', component.options)
    }
    module.hot.accept("./RigaDistintaListaVariazioni.vue?vue&type=template&id=4a125c32&scoped=true", function () {
      api.rerender('4a125c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/RigaDistintaListaVariazioni.vue"
export default component.exports